// extracted by mini-css-extract-plugin
export default {"preview_text":"ImageFieldNoEditView_preview_text__q+tlm","preview_wrapper":"ImageFieldNoEditView_preview_wrapper__lTA2Q"};